export default __webpack_public_path__ + "static/media/closer-alt.830ff1ca.mp3";